import React, { useState, useEffect, useMemo } from 'react'
import { useParams, Link } from "react-router-dom"
import axios from "axios"
import Nav from './Nav'
import Pagination from '../pages/paginations'

const View = () => {
    // Sesuaikan param dengan yang ada di App.js (:kluster)
    const { kluster } = useParams()
    const [currentPage, setCurrentPage] = useState(1)
    const [PageSize] = useState(12)
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    // Helper format teks buat tampilan (bukan buat URL)
    const formatDisplay = (slug) => {
        if (!slug) return ""
        return slug.replaceAll('-', ' ').replaceAll('_', '/')
    }

    const kategoriClean = formatDisplay(kluster)

    useEffect(() => {
        getData(kluster, '')
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }, [kluster])

    const getData = async (slug, keyword) => {
        setLoading(true)
        try {
            // Gunakan slug dari URL (misal: 'pendidikan-dan-kebudayaan')
            // Kita biarkan Backend yang mengurus pembersihan formatnya
            const targetCluster = slug || kluster

            const response = await axios.post("/api/csr/portal/filter-cluster", {
                cluster: targetCluster, // Kirim slug mentah dari URL
                key: keyword || '',
                jml: 3000
            })

            const result = Array.isArray(response.data) ? response.data : []
            setData(result)
            setCurrentPage(1)
        } catch (err) {
            console.error("Gagal ambil data:", err)
            setData([])
        } finally {
            setLoading(false)
        }
    }

    const tableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return data.slice(firstPageIndex, lastPageIndex)
    }, [data, currentPage, PageSize])

    return (
        <header className="ms-hero-page-override-home no-mt pb-4">
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb breadcrumb-slash">
                        <li className="breadcrumb-item">
                            <Link to={'/'} className="btn btn-raised btn-primary br-2 no-m">BERANDA</Link>
                        </li>
                        <li className="breadcrumb-item active text-uppercase">KATALOG TJSL-CSR</li>
                        <li className="breadcrumb-item active text-uppercase">{kategoriClean}</li>
                    </ol>
                    <div className="btn-group w-300">
                        <button type="button" className="btn btn-warning btn-raised dropdown-toggle" data-toggle="dropdown">
                            {kategoriClean.toUpperCase()} <i className="zmdi zmdi-chevron-down right only"></i>
                        </button>
                        {/* Oper fungsi getData biar dropdown bisa trigger refresh data */}
                        <Nav getKategori={getData} />
                    </div>
                </nav>

                <div className="row mt-4">
                    <div className="col-md-12">
                        <h1 className='color-dark font-bold lh-125 text-uppercase'>{kategoriClean}</h1>
                        <p className="lead color-dark">Daftar kontribusi mitra TJSL/CSR pada bidang {kategoriClean.toLowerCase()}</p>
                        <hr />

                        <div className="row mb-4">
                            <div className="col-md-12">
                                <div className="form-group label-floating">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Cari TJSL/CSR atau wilayah..."
                                        onChange={(e) => getData(kluster, e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            {loading ? (
                                <div className="col-md-12 text-center p-5">
                                    <i className="zmdi zmdi-hc-spin zmdi-spinner zmdi-hc-3x color-primary"></i>
                                    <p className="mt-3">Memuat data katalog...</p>
                                </div>
                            ) : tableData.length > 0 ? tableData.map((val, index) => (
                                <div className="col-md-3 mb-4" key={index}>
                                    <Link to={`/csr-katalog/${kluster}/${val._id}`} className="panel panel-default card-hover d-block shadow-sm" style={{ textDecoration: 'none', borderRadius: '10px', overflow: 'hidden', border: '1px solid #eee' }}>
                                        <div className="panel-body no-p">
                                            {/* Badge Status di pojok gambar */}
                                            <div style={{ position: 'relative' }}>
                                                <span className={`badge ${val.status === 'Selesai' ? 'badge-success' : 'badge-primary'}`}
                                                    style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 10 }}>
                                                    {val.status}
                                                </span>
                                                <img
                                                    style={{ width: '100%', height: '180px', objectFit: 'cover' }}
                                                    src={(val.gambar_design && val.gambar_design !== '-') ? val.gambar_design : '/assets/img/default-csr.jpg'}
                                                    alt={val.klaster}
                                                />
                                            </div>

                                            <div className="p-3">
                                                <h4 className='color-dark font-bold mb-1 text-uppercase' style={{
                                                    fontSize: '14px',
                                                    minHeight: '34px', // Kasih min-height biar kalau judulnya pendek, tinggi card tetep sama
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: '2',
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    lineHeight: '1.2'
                                                }}>
                                                    {val.nama_program || 'TJSL/CSR Tanpa Judul'}
                                                </h4>

                                                {/* Format Rupiah buat Nilai TJSL */}
                                                <h3 className='color-primary font-bold mt-1 mb-1' style={{ fontSize: '18px' }}>
                                                    {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(val.nilai_csr)}
                                                </h3>

                                                {/* Deskripsi: Handle HTML & Truncate */}
                                                <div className="color-dark mb-2" style={{ height: '40px', overflow: 'hidden', fontSize: '13px', lineHeight: '1.4', display: '-webkit-box', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical' }}>
                                                    {val.deskripsi ? val.deskripsi.replace(/<[^>]*>?/gm, '').substring(0, 75) + "..." : "Tidak ada deskripsi"}
                                                </div>

                                                <hr style={{ margin: '10px 0' }} />

                                                <p className="text-muted small mb-0" style={{ fontSize: '11px' }}>
                                                    <i className="zmdi zmdi-pin color-danger"></i> {val.kelurahan_csr}, {val.kecamatan_csr}
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            )) : (
                                <div className="col-md-12 text-center p-5">
                                    <h4 className="color-dark">Belum ada data di klaster ini...</h4>
                                </div>
                            )}
                        </div>

                        {data.length > PageSize && (
                            <div className="text-center p-4">
                                <Pagination
                                    currentPage={currentPage}
                                    totalCount={data.length}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    )
}
export default View